import React from 'react'
import PropTypes from 'prop-types'
import useOperation from './hooks/use-operation'
import { isObservable, observable } from 'mobx'
import useOperations from './hooks/use-operations'
import useUUID from './hooks/use-uuid'
import CollectionContext from './collections/contexts/CollectionContext'

function ReadOnlyCollection (props) {

  const repository = useOperations()
  const parentOperation = useOperation()
  const [uuid] = useUUID()

  const namespace = props.namespace
  const operationName = props.operationName
  const operationContext = props.operationContext
  const resourceName = (!props.resourceName && !!parentOperation) ? parentOperation.resource.slug : props.resourceName

  const operationSlug = React.useMemo(() => {
    return repository.buildSlug(namespace, resourceName, operationName, operationContext)
  }, [namespace, resourceName, operationName, operationContext])

  const defaultCollectionValue = observable.array()

  if(operationSlug && defaultCollectionValue.length === 0) {
    const operation = repository.get(namespace, resourceName, operationName, operationContext)
    const newCollection = (operation.data && operation.data.collection) ? operation.data.collection : []
    defaultCollectionValue.replace(newCollection)
  }

  const collectionRef = React.useRef(defaultCollectionValue)
  const collection = collectionRef.current

  React.useEffect(() => {
    if (!operationSlug) {
      return
    }

    const operation = repository.get(namespace, resourceName, operationName, operationContext)

    const newCollection = (operation.data && operation.data.collection) ? operation.data.collection : []
    collection.replace(newCollection)

    operation.onData(uuid, (data) => {

      let _collection = (data && data.collection) ? data.collection : []

      if (!_collection) {
        _collection = []
      }

      if (_collection.length > 0) {
        _collection = _collection.map(collectionEntry => {
          if (!isObservable(collectionEntry)) {
            collectionEntry = observable.map(Object.entries(collectionEntry))
          }

          return collectionEntry
        })
      }

      collection.replace(_collection)
    })

    return () => {
      operation.unsetOnDataCallback(uuid)
    }
  }, [operationSlug])

  return (
    <CollectionContext.Provider value={collection}>
      {props.children}
    </CollectionContext.Provider>
  )
}

ReadOnlyCollection.defaultProps = {
  namespace: 'api',
  resourceName: null,
  operationName: 'index',
  operationContext: null
}

ReadOnlyCollection.propTypes = {
  namespace: PropTypes.string,
  resourceName: PropTypes.string,
  operationName: PropTypes.string,
  operationContext: PropTypes.any
}

export default ReadOnlyCollection
